<template>
    <div>
            <v-btn
      v-show="isMobile && showOnScreen"
      fixed
      top
      right
      fab
      color="primary"
      z-index="100"
      @click="showMobileMenu"
      class="hamburger-btn"
    >
      <v-icon>{{ drawer ? 'mdi-close' : 'mdi-menu' }}</v-icon>
    </v-btn>
<v-navigation-drawer :color="color" v-model="drawer" :permanent="!isMobile && drawer" :mini-variant="mini" app :width="isMobile ? '100%' : '450'" fixed dark>
    <div class="progress" :style="{ height: `${numScroll}%` }"></div>
    <v-list dense nav>
        <v-list-item link v-scroll="onScroll" v-show="toTopBtn" @click="toTop">
            <v-list-item-icon>
                <v-icon>mdi-chevron-up</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>Wróć do góry</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>

    <v-list class="menu-items" dense nav>
        <v-list-item v-for="item in items" :key="item.title" link :disabled="item.disabled" @click="goTo(item.link)">
            <v-list-item-icon>
                <v-icon :class="{ 'costum-icon': item.isCostumIcon }">{{
            item.icon
          }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
    <v-list class="menu-button" dense nav v-if="!this.isMobile">
        <v-list-item @click.stop="mini = !mini" link>
            <v-list-item-icon>
                <v-icon v-if="mini" active class="costum-icon">mdi-menu</v-icon>
                <v-icon v-else>mdi-chevron-left</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>Menu</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
        <v-list class="menu-button" dense nav v-else>
        <v-list-item @click.stop="showMobileMenu" link>
            <v-list-item-icon>
                <v-icon v-if="mini" active class="costum-icon">mdi-menu</v-icon>
                <v-icon v-else>mdi-chevron-left</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>Menu</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</v-navigation-drawer>
    </div>

</template>

<script>
//import Stack from "@/assets/icons/rockrms.svg"
export default {
    name: "Menu",
    components: {},
    data() {
        return {
            drawer: false,
            showOnScreen: false,
            permanent: true,
            mini: true,
            items: [{
                    title: "Oferta",
                    icon: "",
                    disabled: true,
                },
                {
                    title: "PREFABRYKACJA SZAF STEROWNICZYCH",
                    icon: "$prefabrication",
                    isCostumIcon: true,
                    link: "prefabrykacja",
                },
                {
                    title: "Modernizacja sterowania maszyn przemysłowych",
                    icon: "$modernization_machinery_control",
                    isCostumIcon: true,
                    link: "modernizacja",
                },
                {
                    title: "Automatyzacja produkcji",
                    icon: "$automatic_production",
                    isCostumIcon: true,
                    link: "automatyzacja",
                },
                {
                    title: "CE",
                    icon: "$ce",
                    isCostumIcon: true,
                    link: "ce",
                },
                {
                    title: "Współpraca z konstruktorami",
                    icon: "$cooperation",
                    isCostumIcon: true,
                    link: "wspolpraca",
                },
                {
                    title: "O firmie",
                    icon: "",
                    disabled: true,
                },
                {
                    title: "Informacje",
                    icon: "$info",
                    isCostumIcon: true,
                    link: "informacje",
                },
                {
                    title: "Realizacje",
                    icon: "$realizations",
                    isCostumIcon: true,
                    link: "realizacje",
                },
                {
                    title: "Kontakt",
                    icon: "mdi-phone",
                    link: "kontakt",
                },
            ],
            color: "primary",
            miniVariant: true,
            expandOnHover: true,
            toTopBtn: false,
            numScroll: 0,
            width: "450",
        };
    },
    methods: {
        onScroll(e) {
            if (typeof window === "undefined") return;
            const top = window.pageYOffset || e.target.scrollTop || 0;
            if (top > window.innerHeight / 2) {
                this.showOnScreen = true;
                if (!this.isMobile)   this.drawer = true;
                this.toTopBtn = true;
            } else {
                this.drawer = false;
                      this.showOnScreen = false;
            }
            this.numScroll =
                (100 / (document.body.scrollHeight - window.innerHeight)) * top;
        },
        toTop() {
            this.$vuetify.goTo(0);
        },
        goTo(target) {
            this.$vuetify.goTo(`#${target}`, {
                offset: 100,
            });

            if (this.isMobile)  this.drawer = false; 
        },
        showMobileMenu() {
            this.mini = false; 
            this.drawer = !this.drawer; 
        },
    },
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        },
    },
    mounted() {
        if (this.isMobile) {
            this.width = "100%";
             this.mini = false;
        } else {
            this.mini = true;
        }
    },
};
</script>

<style lang="scss" scoped>
.menu-button {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #0000004f !important;
}

.menu-items {
    position: absolute;
    top: 50%;
    transform: translate(0px, -50%);
    width: 100%;
}

.progress {
    background: red;
    width: 5px;
    height: 100px;
    position: absolute;
    right: 0px;
    z-index: 99;
}

</style>
